import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from "react";
import { GeoMapLeafletCore, } from "../GeoMapLeafletCore";
export const GeoMapLeaflet = forwardRef(function GeoMapLeaflet(props, ref) {
    return (_jsx(GeoMapLeafletCore, Object.assign({}, props, { ref: ref })));
});
